module.exports = __webpack_public_path__ + "static/media/PM13.34a2e7a7.png";